module.exports = __webpack_public_path__ + "img/zhanghua-book.65ef2a95.png";